import(/* webpackMode: "eager" */ "/home/ubuntu/download/69ac6308886e10001423d297/fornaxglobal/src/app/not-found.tsx");
